/**
 * governance/utils/issueSummary.ts
 * Issue aggregation helpers: summarize and score collections of validation issues.
 */

import { type SeverityLevel, SEVERITY_WEIGHTS, isBlockingSeverity } from './severity';
export interface IssueSummary {
  critical: number;
  warning: number;
  info: number;
  total: number;
  blocking: number;
}
export function summarizeIssues(issues: Array<{
  severity: SeverityLevel;
}>): IssueSummary {
  const summary: IssueSummary = {
    critical: 0,
    warning: 0,
    info: 0,
    total: 0,
    blocking: 0
  };
  for (const issue of issues) {
    summary[issue.severity]++;
    summary.total++;
    if (isBlockingSeverity(issue.severity)) summary.blocking++;
  }
  return summary;
}
export function computeQualityScore(issues: Array<{
  severity: SeverityLevel;
}>, total: number): number {
  if (total === 0) return 100;
  const penalty = issues.reduce((acc, i) => acc + (SEVERITY_WEIGHTS[i.severity] ?? 0), 0);
  const maxPenalty = total * SEVERITY_WEIGHTS.critical;
  return Math.max(0, Math.round(100 - penalty / maxPenalty * 100));
}